export default __webpack_public_path__ + "static/media/lv11.c7a39aa3.png";